import React, { useState } from "react"
import {
  Box,
  Collapse,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Typography,
} from "@material-ui/core"
import ExpandLessIcon from "@material-ui/icons/ExpandLess"
import ExpandMoreIcon from "@material-ui/icons/ExpandMore"
import { useTranslation } from "react-i18next"
import enIcon from "src/assets/img/languageIcons/en_32.png"
import esIcon from "src/assets/img/languageIcons/es_32.png"
import { useAccountMenuStyles } from "./accountMenuStyles"

const languages = [
  {
    code: "es",
    label: "Español",
    icon: esIcon,
  },
  {
    code: "en",
    label: "English",
    icon: enIcon,
  },
]

const LanguageSelector = () => {
  const classes = useAccountMenuStyles()
  const { i18n } = useTranslation()
  const [open, setOpen] = useState(false)
  const selectedLang = i18n.language || "es"
  const currentLanguage = languages.find(lang => lang.code === selectedLang)

  const handleToggle = () => setOpen(prev => !prev)

  const handleSelector = lang => {
    i18n.changeLanguage(lang)
    setOpen(false)
  }

  return (
    <Box className={classes.section}>
      <MenuItem
        divider={false}
        onClick={handleToggle}
        className={classes.menuItemLevel1}
      >
        <Box
          display="flex"
          alignItems="center"
          width="100%"
          justifyContent="space-between"
        >
          <Box display="flex" alignItems="center" minWidth={0} flex={1}>
            <img
              src={currentLanguage?.icon}
              alt={selectedLang}
              style={{ width: 16, height: 16, marginRight: 8 }}
            />
            <Box minWidth={0}>
              <Typography className={classes.menuItemSublabel}>
                Idioma
              </Typography>
              <Typography className={classes.menuItemValue} noWrap>
                {currentLanguage?.label}
              </Typography>
            </Box>
          </Box>
          {open ? (
            <ExpandLessIcon fontSize="small" className={classes.expandIcon} />
          ) : (
            <ExpandMoreIcon fontSize="small" className={classes.expandIcon} />
          )}
        </Box>
      </MenuItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List
          component="div"
          disablePadding
          dense
          className={classes.nestedList}
        >
          {languages.map(lang => (
            <ListItem
              key={lang.code}
              button
              dense
              selected={selectedLang === lang.code}
              className={`${classes.nestedItem} ${selectedLang === lang.code ? classes.selectedItem : ""}`}
              onClick={() => handleSelector(lang.code)}
            >
              <ListItemIcon style={{ minWidth: 28 }}>
                <img
                  src={lang.icon}
                  alt={lang.code}
                  style={{ width: 16, height: 16 }}
                />
              </ListItemIcon>
              <ListItemText
                className={classes.nestedItemText}
                primary={lang.label}
                primaryTypographyProps={{
                  className: classes.nestedItemLabel,
                  variant: "body2",
                }}
              />
            </ListItem>
          ))}
        </List>
      </Collapse>
    </Box>
  )
}

export default LanguageSelector
